<template>
  <div class="bid-ask-page">
    <CapitalFlow />
    <template v-if="isShowBrokerStockHoldings">
      <TopTenBrokers class="section-margin-top" />
      <BrokerProportion />
    </template>
    <!-- ID1003194 日股和美股的ETF隐藏所属板块 -->
    <template v-else-if="market === 'us' && $route.query.isEtf === '0'">
      <BlongPlate class="section-margin-top" />
    </template>
    <template v-else-if="market === 'jp' && $route.query.isEtf === '0'">
      <BlongPlate class="section-margin-top" />
    </template>
  </div>
</template>

<script>
import CapitalFlow from '@/components/bidask/capitalFlow/CapitalFlow.vue'
import TopTenBrokers from '@/components/bidask/TopTenBrokers.vue'
import BrokerProportion from '@/components/bidask/brokers/BrokerProportion.vue'
import BlongPlate from '@/components/bidask/BlongPlate.vue'
export default {
  components: {
    CapitalFlow,
    TopTenBrokers,
    BrokerProportion,
    BlongPlate
  },
  data() {
    return {
      erd: null
    }
  },
  computed: {
    isShowBrokerStockHoldings() {
      if (this.market !== 'hk') {
        return false
      }

      return localStorage.getItem('brokerStockHoldings') === '1'
    },
    symbol() {
      return this.$route.query.symbol
    },
    market() {
      return this.$funs.getMarket(this.symbol)
    }
  }
}
</script>
